import getCheckoutAgreements from './getCheckoutAgreements';

export default getCheckoutAgreements;
